export default __webpack_public_path__ + "static/media/szafy4.1d303ab5.jpg";